import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation.js";
import React from "react";

/**
 * Dynamically load translation files pertaining to the profile module.
 * @return {*}
 */
export default function useTranslationProfile() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/profile.json'),
    'fr': import('./locales/fr/profile.json')
  }), []);

  return useModuleTranslation('profile', imports);
}
